"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DurationBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _colorAlpha = _interopRequireDefault(require("color-alpha"));

var _useColors = _interopRequireDefault(require("../../hooks/use-colors"));

var _useToolMode3 = _interopRequireDefault(require("../../hooks/use-tool-mode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Container = (0, _styles.styled)("div")(function (_ref) {
  var width = _ref.width,
      active = _ref.active,
      color = _ref.color;
  return {
    width: width,
    height: 20,
    borderBottom: "1px solid rgba(0,0,0, 0.2)",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    backgroundColor: active ? (0, _colorAlpha.default)(color, 0.2) : "rgba(0,0,0,0)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.2)"
    }
  };
});
var Box = (0, _styles.styled)("div")(function (_ref2) {
  var x = _ref2.x,
      width = _ref2.width,
      color = _ref2.color;
  return {
    position: "absolute",
    left: x,
    width: width,
    overflow: "hidden",
    opacity: 0.8,
    backgroundColor: color,
    height: 20,
    "& div": {
      paddingLeft: 4,
      mixBlendMode: "hardlight",
      whiteSpace: "pre",
      color: "#fff"
    }
  };
});
var Label = (0, _styles.styled)("div")(function (_ref3) {
  var colors = _ref3.colors;
  return _objectSpread({
    position: "absolute",
    pointerEvents: "none",
    left: 4,
    top: 0
  }, colors.dark ? {
    mixBlendMode: "overlay",
    color: "#fff"
  } : {
    mixBlendMode: "multiply",
    color: "#888"
  });
});

var DurationBox = function DurationBox(_ref4) {
  var width = _ref4.width,
      color = _ref4.color,
      active = _ref4.active,
      durations = _ref4.durations,
      visibleTimeStart = _ref4.visibleTimeStart,
      visibleTimeEnd = _ref4.visibleTimeEnd,
      onClick = _ref4.onClick,
      onRemoveBox = _ref4.onRemoveBox,
      onClickBox = _ref4.onClickBox,
      _ref4$isMiscLayer = _ref4.isMiscLayer,
      isMiscLayer = _ref4$isMiscLayer === void 0 ? false : _ref4$isMiscLayer,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? "" : _ref4$label;

  var _useToolMode = (0, _useToolMode3.default)(),
      _useToolMode2 = _slicedToArray(_useToolMode, 1),
      toolMode = _useToolMode2[0];

  var colors = (0, _useColors.default)();
  var visibleDuration = visibleTimeEnd - visibleTimeStart;
  return /*#__PURE__*/_react.default.createElement(Container, {
    onClick: onClick,
    width: width,
    color: color,
    active: active
  }, durations.map(function (_ref5, i) {
    var startTime = _ref5.start,
        endTime = _ref5.end,
        durationLabel = _ref5.label,
        durationColor = _ref5.color;
    var startX = (startTime - visibleTimeStart) / visibleDuration * width;
    var endX = (endTime - visibleTimeStart) / visibleDuration * width;
    if (endX < 0) return null;
    if (isNaN(startX) || isNaN(endX)) return null;
    return /*#__PURE__*/_react.default.createElement(Box, {
      key: i,
      color: durationColor || color,
      x: startX,
      width: endX - startX,
      onClick: function onClick() {
        return onClickBox(i);
      },
      onMouseUp: function onMouseUp(e) {
        if (toolMode === "delete" || e.button === 2 || e.button === 1) {
          onRemoveBox(i);
        }
      },
      onContextMenu: function onContextMenu(e) {
        e.preventDefault();
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, durationLabel));
  }), (label || isMiscLayer && durations.length === 0) && /*#__PURE__*/_react.default.createElement(Label, {
    colors: colors,
    key: "label"
  }, isMiscLayer && durations.length === 0 ? "click to create durations" : label));
};

exports.DurationBox = DurationBox;
var _default = DurationBox;
exports.default = _default;